import Vue from 'vue';
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
  componentPrefix: 'vc',

  locale: 'id-ID',
  locales: {
    'id': {
      firstDayOfWeek: 2,
      masks: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
        dayPopover: 'WWW, MMM D, YYYY',
        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
      }
    },
    'id-full': {
      firstDayOfWeek: 2,
      masks: {
        title: 'MMMM YYYY',
        weekdays: 'WWWW',
        navMonths: 'MMM',
        input: ['YYYY-MM-DD', 'YYYY/MM/DD'],
        dayPopover: 'WWW, MMM D, YYYY',
        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
      }
    },
  }

})
